let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aQnhg")).then(() => parcelRequire('1zg3D'));